import React, { useRef, useEffect, useState } from 'react';
import '../../styles/audiobook/AudioLoadingModal.scss';
import { Player } from '@lottiefiles/react-lottie-player';
import ProgressBar from '../utils/ProgressBar';

const AudioLoadingModal = ({ onDone }) => {
    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(true);

    useEffect(() => {
        if (audioRef.current) {
            const audio = audioRef.current;
            audio.volume = 0;
            audioRef.current.play().catch((error) => {
                console.error('오디오 재생에 실패했습니다.', error);
            });

            const targetVolume = 0.15;
            const duration = 2000;
            const steps = 20;
            const stepTime = duration / steps;
            let currentStep = 0;

            const fadeInterval = setInterval(() => {
                currentStep++;
                const newVolume = (targetVolume / steps) * currentStep;
                audio.volume = Math.min(newVolume, targetVolume);

                if (currentStep >= steps) {
                    clearInterval(fadeInterval);
                    audio.volume = targetVolume;
                }
            }, stepTime);
        }
    }, [isPlaying]);

    return (
        <div className="audio-loading-bg">
            <audio
                ref={audioRef}
                src="/audio/AIMagickid.mp3"
                loop
            />
            <figure className="loading-flag">
                <img
                    src={'/images/audiobook/loading-flag.svg'}
                    alt=""
                />
            </figure>
            <ProgressBar />
            <figure className="loading-text">
                <img
                    src={'/images/audiobook/loading-text.svg'}
                    alt=""
                />
            </figure>
            <Player
                src={'/lottie/sleepLoading.json'}
                className="sleepLoading"
                loop
                autoplay
            />
        </div>
    );
};

export default AudioLoadingModal;
